/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'
import zIndex from '@mui/material/styles/zIndex';


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  placement: {
    '& .label': {
      fontWeight: '700 !important',
      minWidth: pxToEm(100)
    },
    '& .copysnippetfield': {
      width: '100%'
    },
    '& .name-menuItems': {
      zIndex: '999 !important',
      position: 'relative'
    },
    '& .field': {
      width: '100%'
    },
    '& .type-checkbox': {
      alignItems: 'start' 
    },
    '& .singleselectdropdown': {
      width: '100%',
      zIndex: 'auto'
    },
    width: '50%',
    '& .radiospan': {
      width: pxToEm(20),
      height: pxToEm(20),
      '&::after': {
        top: pxToEm(5),
        left: pxToEm(5),
        width: pxToEm(6),
        height: pxToEm(6)
      }
    },
    '& .disabled-true': {
      pointerEvents: 'none',
      opacity: 0.5
    }
  }
});
